module.exports = __webpack_public_path__ + "img/pic_home_technology_3.a072386a.png";